import { PATHS } from '../components/Routes';

export const version = "1.3.2.328 от 11.09.2026";

export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL;

const transformList = (list, name, value, secondName) =>
  list
    ? list.map((f) => ({
      name: `${f[name]} ${secondName ? f[secondName] : ''}`,
      value: f[value],
    }))
    : list;

const transformWeekList = (list) =>
  list
    ? list.map((f) => ({
      name: `${f.week_name} (${f.week_start} - ${f.week_end})`,
      value: f.week_id,
    }))
    : list;

export const getYearsArr = () => {
  let year = new Date().getFullYear();
  const res = [];
  while (year >= 2016) {
    res.push(year);
    year--;
  }
  return res;
};

export const transformFaculties = (facultyList) =>
  transformList(facultyList, 'faculty', 'idfaculty');

export const transformYears = (yearsList) => transformList(yearsList, 'name', 'xp_key').reverse();

export const transformWeeks = (weekList) => transformWeekList(weekList, 'week_name', 'week_id');

export const transformCathedras = (cathedraList) =>
  transformList(cathedraList, 'cathedra', 'idcathedra');

export const transformEducationYear = (educationYear) =>
  transformList(educationYear, 'name', 'eyid');

export const transformCourses = (courses) => transformList(courses, 'title', 'cid');

export const transformCourses_course = (courses) => transformList(courses, 'course', 'cid');

export const transformTerms = (terms) => transformList(terms, 'title', 'trmid');

export const transformStudents = (terms) => transformList(terms, 'lastname', 'mid', 'firstname');

export const transformateTerms = (terms) => transformList(terms, 'name', 'tlid');

export const selectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: '#7b2b2a',
    borderRadius: '50px',
    fontSize: '11px',
    lineHeight: '15px',
    minHeight: '0px',
    width: '680px',
    backgroundPosition: '98% center',
    backgroundImage:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA8xpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wUmlnaHRzPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvcmlnaHRzLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcFJpZ2h0czpNYXJrZWQ9IkZhbHNlIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InV1aWQ6ODUxOERBRjZCOURFRTQxMTlDNzY4MDY1MUJGNTAxQ0UiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzM3NUVDNUZDM0Q4MTFFN0JDOTZCMDlGNjQzOEIwNUUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzM3NUVDNUVDM0Q4MTFFN0JDOTZCMDlGNjQzOEIwNUUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OWVlYTI5ZmItNmQwZi0xMTQzLWIyOGUtZmM2MmU2MDY0YWNjIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ZjI3Y2RmMjEtYjRkNy0xMWU3LTg2OTItY2FlOTU4ZTFmN2IxIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VYI5dgAAAKxJREFUeNpi+v//PwMyjldW6gTifnRxJgZM4A3E/uiCLFgUPgNiTnRBbCZiBdRXyJKgohwPpG8suHP3JDYFQHkTIKUNMtERiE8ABXShcmxQDFKkAaROA7EbIyiMgAJLgZwoIBYA4nYg5gbiLCD+AsTrgLYFg90IZEQDqRVA/AGItYBYCYg/AvF6kCKQGrCJSO5ZCaTCoNxNQEXwgEdRCFW8HEixAhWFIIsDBBgAI11HlZ3FYMIAAAAASUVORK5CYII=)',
    backgroundRepeat: 'no-repeat',
  }),
  indicatorSeparator: (baseStyles, state) => ({
    display: 'none', // Скрываем стандартную разделитель
  }),
  indicatorsContainer: (baseStyles, state) => ({
    color: 'white',
    display: 'none', // Скрываем стандартную галочку
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: '#757575',
    fontSize: '11px',
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    width: '680px',
    color: '#757575',
    fontSize: '11px',
    lineHeight: '15px',
    minHeight: '0px',
    overflow: 'hidden',
    top: '50%',
    margin: '0px',
    padding: '0px',
  }),
};

// access у пункта меню: пара ['Раздел', 'Право'] либо список пар — доступ по любой из них.
// Проверка применяется только в ЛК постоянного состава (см. MenuLink, проп checkAccess).
// Пункты без access видны всегда.
export const UNITS_SUBMENU = [
  {
    name: 'Структура образовательной организации',
    to: '/units',
    access: ['Справочники', 'Структура образ. организации'],
  },
  {
    name: 'Факультеты',
    to: '/faculty',
    access: [
      ['Справочники', 'Факультеты'],
      ['Справочники', 'Факультеты. Администратор'],
    ],
  },
  {
    name: 'Кафедры',
    to: '/cathedra',
    access: [
      ['Справочники', 'Кафедры'],
      ['Справочники', 'Кафедры. Администратор'],
    ],
  },
  /* { name: 'Формирование групп', to: '/groups' }, */
  {
    name: 'Постоянный состав',
    to: '/permanent_stuff',
    access: [
      ['Справочники', 'Постоянный состав'],
      ['Справочники', 'Постоянный состав. Администратор'],
    ],
  },
  {
    name: 'Переменный состав',
    to: '/variable_stuff',
    access: [
      ['Справочники', 'Переменный состав'],
      ['Справочники', 'Переменный состав. Администратор'],
    ],
  },
  { name: 'Кандидаты', to: '/applicant', access: ['Справочники', 'Кандидаты'] },
  /* { name: 'Обмен данными' }, */
  { name: 'Расход личного состава', to: '/personnel' },
  /* { name: 'Приказы', to: '/orders' }, */
  {
    name: 'Документы об образовании',
    to: '/education_documents',
    access: ['Режимы', 'Документы об образовании. Книга регистрации выданных документов об образовании'],
  },
  { name: 'Портфолио', to: '/portfolio' },
  { name: 'Видеокамеры', to: '/streams', access: ['Настройка', 'Видеокамеры'] },
];

export const THEMATIC_PLANNING_ACCESS = [
  ['Режимы', 'Тематическое планирование'],
  ['Режимы', 'Тематическое планирование. Администратор'],
];

// Виды аттестации (exam_kind API /cert/*)
export const EXAM_KIND = {
  INTERMEDIATE: 2,
  FINAL: 3,
};

// Имена прав воспроизводят базу посимвольно: у промежуточной админ-право
// без пробела после точки, у итоговой — с пробелом.
export const INTERMEDIATE_CERTIFICATION_ACCESS = [
  ['Режимы', 'Промежуточная аттестация'],
  ['Режимы', 'Промежуточная аттестация.Администратор'],
];

export const FINAL_CERTIFICATION_ACCESS = [
  ['Режимы', 'Итоговая аттестация'],
  ['Режимы', 'Итоговая аттестация. Администратор'],
];

export const STUDIES_SUBMENU = [
  {
    name: 'Наименование разделов и тем по РПД',
    to: '/program_modules',
    access: [
      ['Режимы', 'Наименования разделов и тем по РПД'],
      ['Режимы', 'Наименования разделов и тем по РПД. Администратор'],
    ],
  },
  {
    name: 'Рабочие программы дисциплин',
    to: '/disprograms',
    access: [
      ['Справочники', 'Рабочие программы дисциплин (модулей)'],
      ['Справочники', 'Рабочие программы дисциплин (модулей). Администратор'],
    ],
  },

  {
    name: 'Обеспечение учебной дисциплины литературой',
    to: '/support_study_dis',
  }, // Обеспечение учебной дисциплины

  {
    name: 'Тематические планы',
    to: '/topics',
    access: THEMATIC_PLANNING_ACCESS,
  },
  {
    name: 'Комплексный тем.план (КТП) потоков',
    to: '/flow_plan',
    access: ['Справочники', 'Комплексный тем.план (КТП) потоков']
  },
  {
    name: 'Комплексный тем.план (КТП) дисциплин',
    to: '/complex_topics_disciplines',
    access: ['Справочники', 'Комплексный тем.план (КТП) по дисциплинам']
  },
  {
    name: 'Планы проведения занятий',
    to: '/lesson_plan',
    access: [
      ['Режимы', 'План проведения занятий'],
      ['Режимы', 'План проведения занятий. Администратор'],
    ],
  },
  { name: 'Расписание', to: '/schedule' },
  { name: 'Личное расписание преподавателя', to: '/teacher_schedule' },
  {
    name: 'Журнал учета учебных занятий',
    to: '/journal',
    access: [
      ['Режимы', 'Журнал учета учебных занятий'],
      ['Режимы', 'Журнал учета учебных занятий. Администратор'],
    ],
  },
  {
    name: 'Промежуточная аттестация',
    to: '/intermediate_certification',
    access: INTERMEDIATE_CERTIFICATION_ACCESS,
  },
  {
    name: 'Итоговая аттестация',
    to: '/final_certification',
    access: FINAL_CERTIFICATION_ACCESS,
  },
  { name: 'Работы/проекты обучающегося', to: '/student_projects_teacher' },
  {
    name: 'Индивидуальный план работы',
    to: '/individual_work_plan',
    access: [
      ['Справочники', 'Индивидуальные планы работы преподавателя'],
      ['Справочники', 'Индивидуальные планы работы преподавателя. Администратор'],
      ['Справочники', 'Индивидуальные планы работы преподавателя. Подразделение'],
    ],
  },
  /* { name: 'Дисциплины', to: '/disciplines' }, */
  { name: 'Заказ на подбор литературы', to: '/booksrequest' },
  { name: 'Заказ на поставку литературы', to: '/newbook' },
];

export const PERFORMANCES_SUBMENU = [
  { name: 'Текущая успеваемость - журнал занятий', to: '/current_performance' },
  { name: 'Промежуточная аттестация', to: '/performances' },
  { name: 'Итоговая аттестация', to: '/final_performance' },
  { name: 'Работы/проекты обучающегося', to: '/student_projects' },
];

export const TECHNIQUE_SUBMENU = [
  { name: 'План мероприятий', to: '/plan' },
  // Методический кабинет ЛК постоянного состава (/meto_room). Одноимённый режим
  // ЛК переменного состава живёт в LIBRARY_SUBMENU (/library) и правом не закрывается.
  { name: 'Методический кабинет', to: '/meto_room', access: ['Режимы', 'Методический кабинет'] },
  {
    name: 'План методической деятельности',
    to: '/meto_activity',
    access: ['Режимы', 'План методической деятельности вуза на учебный год'],
  },
  {
    name: 'ЭУМК',
    to: '/umkTeacher',
    access: [
      ['Режимы', 'ЭУМК'],
      ['Режимы', 'ЭУМК. Администратор'],
    ],
  },
  // { name: "Тесты", to: "/tests" },
];

export const SCIENTIFIC_SUBMENU = [
  { name: 'Научные работы', to: '/scientific_work', access: ['Режимы', 'Научные работы'] },
];

export const FACULTY_SUBMENU = [{ name: 'КТП', to: '/ktp' }];

export const SCHEDULE_SUBMENU = [
  { name: 'Расписание', to: '/schedule' },
  { name: 'Индивидуальное расписание на дату', to: '/schedule_on_date' },
];

export const EDUCATION_SUBMENU = [
  { name: 'Направления подготовки' },
  { name: 'Образовательные стандарты' },
];

export const STRUCTURE_SUBMENU = [
  { name: 'Факультеты' },
  { name: 'Кафедры' },
  { name: 'Структурные подразделения' },
];

export const INFORMATION_SUBMENU = [
  { name: 'Историческая справка о военном институте' },
  { name: 'Официальная символика военного института' },
  { name: 'Схема проезда' },
  { name: 'Прием обращений' },
];

export const REPORT_SUBMENU = [
  {
    name: 'Ввод индивидуальных достижений',
    to: '/report',
    access: [
      ['Режимы', 'Ввод индивидуальных достижений'],
      ['Режимы', 'Ввод индивидуальных достижений. Администратор'],
    ],
  },
  {
    name: 'Рейтинг-распределение и цифровой портрет',
    to: '/digital_rating',
    access: [
      ['Режимы', 'Рейтинг распределение и цифровой портрет'],
      ['Режимы', 'Рейтинг распределение и цифровой портрет. Администратор'],
    ],
  },
  {
    name: 'Показатели деятельности вуза',
    to: `/dashboard/list/all`,
    access: ['Режимы', 'Показатели деятельности вуза']
  },
  { name: 'Аккредитационные показатели', to: `/dashboard_new/accreditation` },
  {
    name: 'Формирование списка кандидатов на стипендии Президента РФ, Правительства РФ, МО РФ',
    to: `/grants`,
    access: ['Режимы', 'Формирование списка кандидатов на стипендии'],
  },
];

export const SETTINGS_SUBMENU = [
  { name: 'Ключи шифрования', to: '/encryption_keys', access: ['Настройка', 'Ключи шифрования'] },
  {
    name: 'Критерии оценки качеств преподавателей для опроса обучающихся',
    to: '/criterias',
    access: ['Справочники', 'Критерии оценки качеств преподавателей для опроса обучающихся'],
  },
  {
    name: 'Настройка информационных экранов',
    to: '/info_kiosk',
    access: ['Настройка', 'Информационный терминал'],
  },
  {
    name: 'Информационный терминал. Конструктор схемы',
    to: '/info_terminal',
    access: ['Настройка', 'Информационный терминал'],
  },
];

export const UMK_SUBMENU = [{ name: 'Учебный план', to: '/umk' }];

export const CREDITS_SUBMENU = [{ name: 'Зачетная книжка', to: '/credits' }];

export const PORTFOLIO_SUBMENU = [{ name: 'Портфолио', to: '/portfolio' }];

export const LIBRARY_SUBMENU = [{ name: 'Методический кабинет', to: '/library' }];

export const EDUCATION_MO = [
  { name: 'Руководство программиста', to: '/hlms_manual.pdf', target: true },
  {
    name: 'Дистрибутив ПО «Образование-МО»',
    to: 'http://www.nintegra.ru/files/1.2.299.2115.zip',
    target: false,
  },
];

export const GUEST_SUBGROUP = [
  { name: 'ОБРАЗОВАНИЕ', submenu: EDUCATION_SUBMENU },
  { name: 'СТРУКТУРА И ОРГАНЫ УПРАВЛЕНИЯ', submenu: STRUCTURE_SUBMENU },
  // { name: "ОСНОВНЫЕ СВЕДЕНИЯ", submenu: INFORMATION_SUBMENU },
  // { name: "Образование-МО", submenu: EDUCATION_MO },
];

export const getSubmenu = (path) => {
  switch (path) {
    case PATHS.AUTH.UNITS:
      return UNITS_SUBMENU;
    case PATHS.AUTH.PORTFOLIO:
      return PORTFOLIO_SUBMENU;
    case PATHS.AUTH.LIBRARY:
      return LIBRARY_SUBMENU;
    case PATHS.AUTH.CREDITS:
      return CREDITS_SUBMENU;
    case PATHS.AUTH.UMK:
      return UMK_SUBMENU;
    case PATHS.AUTH.CURRICULUM:
      return STUDIES_SUBMENU;
    case PATHS.AUTH.PLAN:
      return TECHNIQUE_SUBMENU;
    case PATHS.AUTH.FACULTY:
      return FACULTY_SUBMENU;
    case PATHS.AUTH.SCHEDULE:
      return SCHEDULE_SUBMENU;
    case PATHS.AUTH.PERFORMANCES:
      return PERFORMANCES_SUBMENU;
    case PATHS.AUTH.REPORT:
      return REPORT_SUBMENU;
    case PATHS.AUTH.SETTINGS:
      return SETTINGS_SUBMENU;
    case PATHS.AUTH.SCIENTIFIC_WORK:
      return SCIENTIFIC_SUBMENU;
    default:
      return [];
  }
};

/* ============================================================================
   Меню личного кабинета — единый источник для основной навигации
   (TeacherMenu / StudentMenu / MenuLink) и для поиска по пунктам меню
   (components/search/MenuSearch).
   ========================================================================== */

// Уровни доступа, при которых пункт меню виден пользователю
export const MENU_VISIBLE_RIGHTS = ['Чтение', 'Полный'];

// Имена прав в базе местами содержат лишнюю точку в конце
// («Ввод индивидуальных достижений.»), поэтому при промахе по точному ключу
// ищем право по нормализованному имени.
export const normalizeMenuMode = (mode) => String(mode).trim().replace(/\.+$/, '');

export const getMenuRight = (accessModes, groupName, modeName) => {
  const group = accessModes && accessModes[groupName];
  if (!group) return undefined;
  if (group[modeName] !== undefined) return group[modeName];
  const key = Object.keys(group).find((k) => normalizeMenuMode(k) === normalizeMenuMode(modeName));
  return key && group[key];
};

// access может быть одной парой [groupName, modeName] либо списком пар
// (доступ по любой из них). Falsy checkAccess — пункт виден всегда
// (ЛК переменного состава видимость по правам не меняет).
export const hasMenuAccess = (accessModes, access, checkAccess) => {
  if (!checkAccess || !access) return true;
  const pairs = Array.isArray(access[0]) ? access : [access];
  return pairs.some(([groupName, modeName]) =>
    MENU_VISIBLE_RIGHTS.includes(getMenuRight(accessModes, groupName, modeName)));
};

// Верхние пункты меню ЛК постоянного состава — повторяют TeacherMenu.js.
// checkAccess: подпункты фильтруются по правам пользователя.
export const TEACHER_MENU = [
  { name: 'ПОВСЕДНЕВНАЯ ДЕЯТЕЛЬНОСТЬ', to: PATHS.AUTH.UNITS, checkAccess: true },
  { name: 'ОБРАЗОВАТЕЛЬНАЯ ДЕЯТЕЛЬНОСТЬ', to: PATHS.AUTH.CURRICULUM, checkAccess: true },
  { name: 'МЕТОДИЧЕСКАЯ РАБОТА', to: PATHS.AUTH.PLAN, checkAccess: true },
  { name: 'НАУЧНАЯ РАБОТА', to: PATHS.AUTH.SCIENTIFIC_WORK, checkAccess: true },
  { name: 'ОТЧЕТНОСТЬ', to: PATHS.AUTH.REPORT, checkAccess: true },
  { name: 'НАСТРОЙКИ', to: PATHS.AUTH.SETTINGS, checkAccess: true },
];

// Верхние пункты меню ЛК переменного состава — повторяют StudentMenu.js.
// Без checkAccess: видимость подпунктов по правам не сужается.
export const STUDENT_MENU = [
  { name: 'Учебный план', to: PATHS.AUTH.UMK },
  { name: 'Зачетная книжка', to: PATHS.AUTH.CREDITS },
  { name: 'Расписание занятий', to: PATHS.AUTH.SCHEDULE },
  { name: 'Успеваемость', to: PATHS.AUTH.PERFORMANCES },
  { name: 'Портфолио', to: PATHS.AUTH.PORTFOLIO },
  { name: 'Методический кабинет', to: PATHS.AUTH.LIBRARY },
];

// Плоский список конечных пунктов меню текущего пользователя для поиска:
// группирующие верхние пункты в него не входят, подпункты без доступа отсеяны,
// повторяющийся роут (напр. /schedule) остаётся один раз.
export const getMenuSearchItems = (isTeacher, accessModes) => {
  const tops = isTeacher ? TEACHER_MENU : STUDENT_MENU;
  const seen = new Set();
  const items = [];
  tops.forEach((top) => {
    getSubmenu(top.to).forEach((leaf) => {
      if (!leaf.to || seen.has(leaf.to)) return;
      if (!hasMenuAccess(accessModes, leaf.access, top.checkAccess)) return;
      seen.add(leaf.to);
      items.push({ name: leaf.name, to: leaf.to });
    });
  });
  return items;
};

export const MONTHS = [
  { name: 'сентябрь', value: 9 },
  { name: 'октябрь', value: 10 },
  { name: 'ноябрь', value: 11 },
  { name: 'декабрь', value: 12 },
  { name: 'январь', value: 1 },
  { name: 'февраль', value: 2 },
  { name: 'март', value: 3 },
  { name: 'апрель', value: 4 },
  { name: 'май', value: 5 },
  { name: 'июнь', value: 6 },
  { name: 'июль', value: 7 },
  { name: 'август', value: 8 },
];

export const GRADES = [
  { name: 'не указано', value: '' },
  { name: 'неудовлетворительно', value: 2 },
  { name: 'удовлетворительно', value: 3 },
  { name: 'хорошо', value: 4 },
  { name: 'отлично', value: 5 },
];

export const AUTH_ERROR_MESSAGES = {
  401: 'Ошибка отправки имени пользователя в заголовке',
  403: 'Пользователь не существует в СУО',
};

export const AVAILIBLE_FILE_EXTENTIONS = {
  doc: 'doc',
  docx: 'docx',
  flv: 'flv',
  html: 'html',
  jpeg: 'jpeg',
  jpg: 'jpg',
  mkv: 'mkv',
  mp3: 'mp3',
  pdf: 'pdf',
  png: 'png',
  ppt: 'ppt',
  pptx: 'pptx',
  rtf: 'rtf',
  swf: 'swf',
  txt: 'txt',
  url: 'url',
  xls: 'xls',
  xlsx: 'xlsx',
};

export const itemsPerPage = 10;

export const BOOK_SECTIONS = [
  {
    id: 1,
    name: 'Основная литература',
  },
  {
    id: 2,
    name: 'Дополнительная литература',
  },
  {
    id: 3,
    name: 'Учебно-методическое обеспечение самостоятельной работы',
  },
  {
    id: 4,
    name: 'Ресурсы информационно-телекоммуникационной сети интернет',
  },
];

export const itemsOnPage = 15;

export const tableNames = {
  scholarship_higher_education_adjunct: 'Адъюнкты',
  scholarship_higher_education_cadet_listener: 'Слушатели и курсанты ВО',
  // scholarship_higher_education_listener: 'Магистратура',
  // scholarship_higher_education_cadet: 'Специалитет',
  scholarship_secondary_education: 'Курсанты, обучающиеся по образовательным программам СПО',
};

export const tableNamesСandidates = {
  scholarship_candidates_higher_cadet:
    'Кандидаты на назначение стипендий Министерства обороны Российской Федерации из числа курсантов, обучающихся по образовательным программам высшего образования, по очной форме обучения в военных образовательных организациях высшего образования Министер-ства обороны Российской Федерации',
  scholarship_candidates_higher_listener:
    'Кандидаты на назначение стипендий Министерства обороны Российской Федерации из числа слушателей, обучающихся по образовательным программам высшего образования, по очной форме обучения в военных образовательных организациях высшего образования Министерства обороны Российской Федерации',
  scholarship_candidates_higher_adjunct:
    'Кандидаты на назначение стипендий Министерства обороны Российской Федерации из числа адъюнктов, обучающихся по образовательным программам высшего образования, по очной форме обучения в военных образовательных организациях высшего образования Министерства обороны Российской Федерации',
  president_scholarship_candidates_higher_cadet_listener:
    'Кандидаты на назначение стипендий Президента Российской Федерации из числа курсантов и слушателей, обучающихся по образовательным программам высшего образования, по очной форме обучения в военных образовательных организациях высшего образования Министерства обороны Российской Федерации',
  government_scholarship_candidates_higher_cadet_listener:
    'Кандидаты на назначение стипендий Правительства Российской Федерации из числа курсантов и слушателей, обучающихся по образовательным программам высшего образования, по очной форме обучения в военных образовательных организациях высшего образования Министерства обороны Российской Федерации',
  government_scholarship_candidates_secondary_cadet:
    'Кандидаты на назначение стипендий Правительства Российской Федерации из числа курсантов, обучающихся по образовательным программам среднего профессионального образования, по очной форме обучения в военных образовательных организациях Министерства обороны Российской Федерации',
};

export const grantNames = [
  {
    label: 'Президента РФ',
    value: 'Президента РФ',
  },
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantNamesActive = [
  {
    label: 'Президента РФ',
    value: 'Президента РФ',
  },
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantNamesNoMo = [
  {
    label: 'Президента РФ',
    value: 'Президента РФ',
  },
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantNamesActiveNoMo = [
  {
    label: 'Президента РФ',
    value: 'Президента РФ',
  },
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantMiddleNames = [
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantMiddleNamesActive = [
  {
    label: 'Правительства РФ',
    value: 'Правительства РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantAdjunctNames = [
  // {
  //   label: 'Президента РФ',
  //   value: 'Президента РФ'
  // },
  // {
  //   label: 'Правительства РФ',
  //   value: 'Правительства РФ'
  // },
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantAdjunctNamesActive = [
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantAdjunctNamesNoMo = [
  // {
  //   label: 'Президента РФ',
  //   value: 'Президента РФ'
  // }, {
  //   label: 'Правительства РФ',
  //   value: 'Правительства РФ'
  // }
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const grantAdjunctNamesActiveNoMo = [
  // {
  //   label: 'Президента РФ',
  //   value: 'Президента РФ'
  // },
  // {
  //   label: 'Правительства РФ',
  //   value: 'Правительства РФ'
  // }
  {
    label: 'Министерства обороны РФ',
    value: 'Министерства обороны РФ',
  },
  {
    label: 'Исключить',
    value: 'Исключить',
  },
];

export const educationLevelsReNames = {
  Курсант: 'Курсанты ВО',
  Слушатель: 'Слушатели',
  Адъюнкт: 'Адъюнкты',
  СПО: 'Курсанты СПО',
};

export const chapterList = [
  {
    id: 8,
    name: 'Выписка из протокола',
  },
  {
    id: 9,
    name: 'Характеристика-рекомендация',
  },
  {
    id: 10,
    name: 'Служебная характеристика',
  },
];

export const grantsNames = {
  'Министерства обороны РФ': 'именной стипендии Министерства обороны Российской Федерации',
  'Правительства РФ': 'стипендии Правительства Российской Федерации',
  'Президента РФ': 'стипендии Президента Российской Федерации',
};

export const DASHBOARD_ENTITIES = {
  high: {
    ege: {
      name: 'ege_result',
      title: 'Средний балл поступивших по ЕГЭ / ЕГЭ + ДВИ',
      min: 0,
      max: 10,
      path: '/dashboard_new/details/ege',
      options: ['от 65 = 10', 'от 60 до 65 = 5', 'менее 60 = 0'],
    },
    eioc: {
      name: 'eioc_result',
      title: 'ЭИОС',
      min: 0,
      max: 10,
      path: '/dashboard_new/details/eioc',
      options: ['имеется = 10', 'отсутствует = 0'],
    },
    teachers: {
      name: 'teachers_result',
      title: 'Доля преподавателей с учёной степенью/званием',
      min: 0,
      max: 20,
      path: '/dashboard_new/details/teachers',
      options: ['соответствует = 20', 'не соответствует = 0'],
    },
    workers: {
      name: 'workers_result',
      title: 'Доля работников, имеющих стаж работы реализуемой программы',
      min: 0,
      max: 20,
      path: '/dashboard_new/details/staff',
      options: ['соответствует = 20', 'не соответствует = 0'],
    },
    students: {
      name: 'students_result',
      title: 'Доля обучающихся, выполнивших большинство заданий диагностической работы',
      min: 0,
      max: 75,
      path: '/dashboard_new/details/students',
      options: ['от 65 = 75', 'от 55 до 64 = 40', 'менее 55 = 0'],
    },
    vsoko: {
      name: 'vsoko_result',
      title: 'ВСОКО',
      min: 0,
      max: 10,
      path: '/dashboard_new/details/vsoko',
      options: ['имеется = 10', 'отсутствует = 0'],
    },
  },
  spo: {
    workers: {
      name: 'workers_result',
      title: 'Доля работников, имеющих стаж работы реализуемой программы',
      min: 0,
      max: 10,
      path: '/dashboard_new/details_spo/staff',
      options: ['соответствует = 10', 'не соответствует = 0'],
    },
    eioc: {
      name: 'eioc_result',
      title: 'ЭИОС',
      min: 0,
      max: 5,
      path: '/dashboard_new/details_spo/eioc',
      options: ['имеется = 5', 'отсутствует = 0'],
    },
    students: {
      name: 'students_result',
      title: 'Доля обучающихся, выполнивших большинство заданий диагностической работы',
      min: 0,
      max: 20,
      path: '/dashboard_new/details_spo/students',
      options: ['от 65 = 20', 'от 50 до 64 = 10', 'менее 50 = 0'],
    },
    vsoko: {
      name: 'vsoko_result',
      title: 'ВСОКО',
      min: 0,
      max: 10,
      path: '/dashboard_new/details_spo/vsoko',
      options: ['имеется = 10', 'отсутствует = 0'],
    },
  },
};


export const CIUP_STRUCTURE = {
  vo: [
    {
      value: 'educational_activity',
      name: 'Образовательная деятельность',
      criterias: [
        { value: 'npr_candidate_degree_proportion', name: 'Доля НПР имеющих ученую степень', units: '%', min: 25, normal: 50, tags: ['кандидат наук', 'ВО'] },
        { value: 'npr_doctor_degree_proportion', name: 'Доля НПР имеющих ученую степень', units: '%', min: 40, normal: 60, tags: ['доктор наук', 'ВО'] },
      ]
    },
    {
      value: 'research_activity',
      name: 'Научно-исследовательская деятельность',
      criterias: [
        { value: 'niokr_total_volume', name: 'Общий объем НИОКР', units: 'тыс. руб.', min: 200, normal: 500, tags: ['НИОКР', 'ВО'] },
        { value: 'niokr_volume_per_npr', name: 'Объем НИОКР в расчете на одного НПР', units: 'тыс. руб.', min: 80, normal: 150, tags: ['НИОКР', 'ВО'] },
        { value: 'license_agreements_count', name: 'Количество лицензионных соглашений', units: 'шт.', min: 3, normal: 7, tags: ['лицензия', 'ВО'] },
        { value: 'scientific_journals_count', name: 'Число научных журналов, в том числе электронных, издаваемых вузом', units: 'единиц', min: 2, normal: 5, tags: ['научные журналы', 'ВО'] },
      ]
    },
    {
      value: 'infrastructure',
      name: 'Инфраструктура',
      criterias: [
        {
          value: 'area_per_student',
          name: 'Общая площадь учебно-научных помещений в расчёте на одного студента (приведённого контингента)',
          units: 'кв. м.',
          min: 15,
          normal: 30,
          tags: ['учебно-научные помещения', 'ВО'],
          children: [
            { value: 'area_leased', name: 'предоставленных вузу в аренду, безвозмездное пользование', units: 'кв. м.' },
            { value: 'area_operational_management', name: 'закрепленных за вузом на праве оперативного управления', units: 'кв. м.' },
            { value: 'area_owned', name: 'имющихся у вуза на праве собственности', units: 'кв. м.' },
          ]
        },
        { value: 'computers_per_student', name: 'Количество персональных компьютеров в расчёте на одного студента (приведённого контингента)', units: 'единиц', min: 10, normal: 20, tags: ['персональные компьютеры', 'ВО'] },
        { value: 'library_books_per_student', name: 'Количество экземпляров учебно-методической литературы из общего количества единиц хранения библиотечного фонда, состоящих на учёте, в расчёте на одного студента (приведённого контингента)', units: 'единиц', min: 3, normal: 5, tags: ['учебная литература', 'ВО'] },
        { value: 'modern_machines_proportion', name: 'Доля стоимости современных (не старше 5 лет) машин и оборудования в вузе в общей стоимости машин и оборудования', units: '%', min: 20, normal: 40, tags: ['ВО', 'машины и оборудование'] },
      ]
    },
  ],
  spo: [
    {
      value: 'education_quality',
      name: 'Качество образования',
      criterias: [
        { value: 'avg_score_ege', name: 'Средний балл по результатам ОГЭ', units: 'баллов', min: 15, normal: 25, tags: ['ОГЭ', 'СПО', 'основное общее образование'] },
        { value: 'avg_score_gia', name: 'Средний балл по результатам ЕГЭ', units: 'баллов', min: 40, normal: 55, tags: ['ЕГЭ', 'СПО', 'среднее (полное) общее образование'] },
      ]
    },
    {
      value: 'social_protection',
      name: 'Социальная защищенность обучающихся',
      criterias: [
        { value: 'canteen_seats_provision_proportion', name: 'Обеспеченность курсантов посадочными местами в образовательном учреждении или организации для работы подразделений общественного питания', units: '%', min: 50, normal: 80, tags: ['посадочные места', 'СПО'] },
        { value: 'dormitory_provision_proportion', name: 'Обеспеченность нуждающихся курсантов местами в общежитии', units: '%', min: 25, normal: 40, tags: ['общежитие', 'СПО'] },
        { value: 'material_support_proportion', name: 'Доля курсантов, получающих другие формы материальной поддержки (кроме стипендии)', units: '%', min: 10, normal: 20, tags: ['материальная поддержка', 'СПО', 'очная форма'] },
      ]
    },
    {
      value: 'staff_potential',
      name: 'Кадровый потенциал',
      criterias: [
        { value: 'avg_age_npr', name: 'Средний возраст основных (штатных) педагогических работников', units: 'лет', min: 35, normal: 45, tags: ['возраст педагогов', 'СПО'] },
      ]
    },
    {
      value: 'executive_discipline',
      name: 'Уровень исполнительской дисциплины',
      criterias: [
        { value: 'rosobrnadzor_requirements_score', name: 'Результаты выполнения требований Рособрнадзора, связанных с процедурой государственной аккредитации и (или) проведением мероприятий по контролю (надзору), или органов исполнительной власти субъектов РФ, осуществляющих переданные полномочия РФ в области образования', units: '%', min: 50, normal: 80, tags: ['ОГЭ', 'мероприятия по надзору', 'требования', 'правовые акты', 'СПО'] },
        { value: 'normative_compliance_score', name: 'Соблюдение требований нормативных правовых актов, поручений Министерства образования и науки РФ и Рособрнадзора, регламентирующих деятельность учреждения СПО', units: '%', min: 10, normal: 20, tags: ['требования', 'правовые акты', 'СПО'] },
      ]
    },
  ],
  do: [

  ]
}

export const OKIN_OPTIONS = [
  { value: 0, label: 'Все' },
  { value: 1675, label: 'Среднее профессиональное образование' },
  { value: 1676, label: 'Бакалавриат' },
  { value: 1677, label: 'Специалитет' },
  { value: 2562, label: 'Магистратура' },
]